import { render, staticRenderFns } from "./PressPage.vue?vue&type=template&id=b7bf776e&scoped=true"
import script from "./PressPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PressPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PressPage.vue?vue&type=style&index=0&id=b7bf776e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bf776e",
  null
  
)

export default component.exports